import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = useFood();
  const list = data.governing_body || [];
  return (
    <div data-testid="ft-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="orange" testidPrefix="ft-gb-page" />
      </PageBody>
    </div>
  );
}
